
export default {
  beforeRouteLeave(to, from, next) {
    if (this.globe.cleanup) this.globe.cleanup()
    next()
  },

  scrollToTop: true,

  async asyncData({ $api, params, error }) {
    const {
      data: { results },
    } = await $api.wbn.companies.getCompanies({
      params: {
        furl: params.furl,
      },
    })

    if (!results.length) {
      error({
        message: 'That broker was not found',
        statusCode: 404,
      })
    }

    return {
      algoliaCompany: results[0],
    }
  },

  data() {
    return {
      companyUsers: {
        results: [],
        loading: false,
      },

      globe: {
        loading: true,
        cleanup: null,
      },
    }
  },

  async fetch() {
    this.companyUsers.loading = true
    const { data } = await this.$api.wbn.companyUsers.getCompanyUsers({
      params: {
        company: this.algoliaCompany.id,
        hidden: false,
        hide_from_website: '-true',
      },
    })

    this.companyUsers.results = data.results
    this.companyUsers.loading = false
  },

  head() {
    const title = this.algoliaCompany.name

    return {
      title,
      meta: [
        ...this.$helpers.createSEOMeta({
          title: this.$root.context.app.head.titleTemplate.replace('%s', title),
          description: this.algoliaCompany.long_description
            ? this.$helpers.getExcerpt(
                this.algoliaCompany.long_description,
                300
              )
            : '',
          url: this.$config.baseURL + this.$route.fullPath,
          image: this.$helpers.cfImage(this.algoliaCompany.logo),
        }),
      ],
    }
  },

  computed: {
    sortedCompanyLocations() {
      return this.algoliaCompany.locations
        .slice()
        .sort((a, _b) => (a.location_type === 'primary_hq' ? -1 : 1))
    },

    representedCountries() {
      if (
        this.algoliaCompany.representing &&
        this.algoliaCompany.representing.length
      ) {
        return this.algoliaCompany.representing
      }

      return null
    },

    computedMembers() {
      return this.companyUsers.results
        .filter((user) => !user.hidden)
        .filter((user) => {
          return user.given_name && user.family_name
        })
        .sort((a, b) => (a.sort_index || 0) - (b.sort_index || 0))
    },

    getMapPoint() {
      if (!this.algoliaCompany.map_points.length) return []

      return this.algoliaCompany.map_points[0].geometry.coordinates
    },

    showFactsheetDownload() {
      return (
        !this.algoliaCompany.is_associate &&
        !this.algoliaCompany.is_carrier &&
        !this.algoliaCompany.hide_factsheet
      )
    },

    extraFactsheetCountries() {
      const primaryHqLocation = this.algoliaCompany.locations?.find(
        // eslint-disable-next-line camelcase
        ({ location_type }) => location_type === 'primary_hq'
      )

      return this.algoliaCompany.representing
        .filter((country) => !!country)
        .filter(
          (country) =>
            country.toLowerCase() !== primaryHqLocation?.country?.toLowerCase()
        )
    },

    factsheetLabel() {
      return this.algoliaCompany.primary_factsheet_label || 'Company Factsheet'
    },
  },

  methods: {
    onGlobeReady({ snapToPoint, cleanup }) {
      this.globe.loading = false
      this.globe.cleanup = cleanup

      if (this.getMapPoint.length) {
        const [lon, lat] = this.getMapPoint
        snapToPoint(lat, lon)
      }
    },
  },
}
